<template>
  <div class="tab-group" :class="getClasses">
    <el-tabs v-model="tab" @tab-click="onTabClick">
      <el-tab-pane
        v-for="item in items"
        :key="item.id"
        :label="item.text"
        :name="item.id.toString()"
      >
        {{ item.text }}
      </el-tab-pane>
    </el-tabs>
    <slot />
  </div>
</template>

<script>
import ElTabs from 'element-ui/lib/tabs'
import ElTabPane from 'element-ui/lib/tab-pane'

export default {
  components: { ElTabs, ElTabPane },
  props: {
    items: Array,
    // possible properties
    // - id: identifier
    // - text: content to show,
    value: [String, Number],
    layout: {
      type: String,
      default: 'tab',
      validator: (prop) => ['tab', 'button'].includes(prop)
    }
  },
  data() {
    return {
      tab: this.value.toString()
    }
  },
  computed: {
    getClasses() {
      const classes = {}
      if (this.layout) {
        classes[`${this.layout}-layout`] = true
      }

      return classes
    }
  },
  watch: {
    value() {
      this.tab = this.value
    }
  },
  methods: {
    onTabClick(item) {
      this.$emit('input', item.name)
      this.$emit('tab-clicked', item.name)
    }
  }
}
</script>

<style lang="less" scoped>
@import (reference) '~@/assets/less/main.less';

@tab-button-layout-height: 38px;
@tab-button-layout-min-width: 120px;

.tab-group {
  .lh-display(flex);
  .lh-justify-content(space-between);

  &.button-layout {
    .el-tabs {
      ::v-deep {
        .el-tabs__item {
          .lh-transition(
            background-color @anim-duration cubic-bezier(0, 0.5, 0.5, 1)
          );
          .main-shadow;
          .font-semibold;
          .lh-display(inline-flex);
          .lh-align-items(center);
          .lh-justify-content(center);
          .text-shadow;
          font-size: 19px;
          padding: @space-xs @space-xs calc(@space-xs + 1px);
          min-width: @tab-button-layout-min-width;
          height: @tab-button-layout-height;
          background-color: @white;
          color: @blue-mid;
          border-radius: @border-radius-s;

          &.is-top:nth-child(2) {
            padding-left: @space-xs;
          }

          &:not(:last-child) {
            margin-right: @space-s;
          }

          &.is-active {
            border: 1px solid fade(@blue-dark, 4);
          }

          &:not(.is-active) {
            background-color: fade(@grey-dark, 10);
            color: @white;
          }
        }

        .el-tabs__active-bar {
          display: none;
        }

        .el-tabs__nav-wrap {
          &,
          .el-tabs__nav-scroll {
            overflow: unset;
          }

          &:after {
            display: none;
          }
        }
      }
    }
  }

  .el-tabs {
    ::v-deep {
      .el-tabs__content {
        display: none;
      }

      .el-tabs__active-bar {
        background-color: @blue-mid;
      }

      .el-tabs__item {
        .fontsize-s;
        .no-select;
        height: auto;
        color: @grey-dark;
        line-height: normal;
        padding-bottom: 7px;
        padding: 0 @space-xs 7px;

        &.is-top:nth-child(2) {
          padding-left: 0;
        }

        &:not(.is-active) {
          color: fade(@grey-mid, 60);
        }

        > * {
          width: 100%;
        }
      }

      .el-tabs__nav-wrap::after {
        background-color: transparent;
      }
    }
  }
}
</style>
